import API from '../../../../commons/api/api';
import * as actionTypes from '../actions/type';

export const initialState = {
  isProcessing: false,
  isProcessingPoint: false,
  statusCode: null,
  point:0,
  coupons:[],
  coupon:{},
  isProcessingExchange: false,
  exchangeStatus: null
};


const giftboxReducers = (state  = initialState, action) => {
  
  switch (action.type) {
    case actionTypes.GET_POINT:
      return { 
        ...state, 
        isProcessingPoint: true, 
        type: action.type,
      };
    case actionTypes.GET_POINT_SUCCESS:
      let res = action.payload;
      return {
        ...state,
        isProcessingPoint: false,
        type: action.type,
        point: res.data?.balance
      };
    case actionTypes.GET_COUPON:
      return {
        ...state,
        isProcessing: true,
        type: action.type,
      };
    case actionTypes.GET_COUPON_SUCCESS:
      let data = action.payload.data?.data
      // if (data && data.length > 0) {
      //   data = data.filter(item => item.coupon_type === 'ONESHOT')
      // }
      return {
        ...state,
        isProcessing: false,
        type: action.type,
        coupons: data || []
      };
    case actionTypes.USE_COUPON:
      return {
        ...state,
        isProcessing: true,
        type: action.type,
        coupon:action.payload
      };
    case actionTypes.RESET_COUPON:
      return {
        ...state,
        isProcessing: true,
        type: action.type,
        coupon:{}
      };
    case actionTypes.EXCHANGE_POINT_TO_COUPON_REQUEST:
      return {
        ...state,
        isProcessingExchange: true,
        type: action.type,
        exchangeStatus: null
      };
    case actionTypes.EXCHANGE_POINT_TO_COUPON_SUCCESS:
      return {
        ...state,
        isProcessingExchange: false,
        type: action.type,
        exchangeStatus: 200
      };
    case actionTypes.EXCHANGE_POINT_TO_COUPON_FAILED:
      return {
        ...state,
        isProcessingExchange: false,
        type: action.type,
        exchangeStatus: 500
      };
    default:
      return state;
  }
};

export default giftboxReducers;
